<div class="side-panel-container" [@slideIn]>
  <div class="side-panel-header">
    @if (title && formType !== FormType.HEALTH_FAIR) {
      <h2 class="side-panel-title">{{ title }}</h2>
    }
  </div>
  <div class="side-panel-content" [@fadeIn]>
    @if (contentTemplate) {
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    } @else if (formType === FormType.TRAINING) {
      <app-training (closeRequested)="close()" [referrer]='referrer' (reloadEvents)="reloadEvents.emit()"></app-training>
    } @else if (formType === FormType.HEALTH_FAIR) {
      <app-healthfair (closeRequested)="close()" [referrer]='referrer' (reloadEvents)="reloadEvents.emit()"></app-healthfair>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
